import { ColumnDef } from "@tanstack/react-table";

import { CaseState, CaseTrackerRow } from "ts/interfaces/caseTracker";
import {
  CLOSED_COLUMNS,
  DEFAULT_COLUMNS,
  OPEN_BANKING_COLUMNS,
  UNDERWRITING_COLUMNS,
} from "./columns";

export interface Stage {
  key: string;
  label: string;
  states: CaseState[];
  columns: ColumnDef<CaseTrackerRow>[];
}

export const STAGES: Stage[] = [
  {
    key: "open-banking",
    label: "Open Banking",
    states: ["OPEN_BANKING"],
    columns: OPEN_BANKING_COLUMNS,
  },
  {
    key: "underwriting",
    label: "Underwriting",
    states: ["UNDERWRITING", "UNDERWRITING_APPROVED"],
    columns: UNDERWRITING_COLUMNS,
  },
  {
    key: "offered",
    label: "Offered",
    states: ["OFFERED"],
    columns: DEFAULT_COLUMNS,
  },
  {
    key: "disbursal-queue",
    label: "Disbursal queue",
    states: ["DISBURSAL_QUEUE"],
    columns: DEFAULT_COLUMNS,
  },
  {
    key: "completed",
    label: "Completed",
    states: ["COMPLETED"],
    columns: CLOSED_COLUMNS,
  },
  {
    key: "rejected",
    label: "Rejected",
    states: ["REJECTED"],
    columns: CLOSED_COLUMNS,
  },
  {
    key: "withdrawn",
    label: "Withdrawn",
    states: ["WITHDRAWN"],
    columns: CLOSED_COLUMNS,
  },
];

export const getStage = (key: string | null) =>
  STAGES.find((stage) => stage.key === key) ?? STAGES[0];
